<mat-card appearance="outlined">
  <mat-card-title>Mandat</mat-card-title>
  @if (isLoading) {
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  }
  @if (!isLoading) {
    <mat-card-content>
      @if (typeReturn === 'validate') {
        <p>
          Merci d’avoir signé votre mandat.<br>
          Nous allons prochainement vous mettre à disposition un service vous permettant de consulter vos échéances de
          prélèvement.
          @if (otherEjs) {
            <span>
              <br>
                Vous avez d'autres missions que vous pouvez passer aussi en prélèvement automatisé, en complétant le formulaire.
              </span>
            }
          </p>
        }
        @if (typeReturn === 'canceled') {
          <p>
            Nous identifions que vous n’êtes pas allé au bout de la démarche de signature de mandat.<br>
            Ce service reste accessible à tout moment. Nous restons à votre écoute.
          </p>
        }
        @if (typeReturn === 'failure') {
          <p>
            Nous identifions qu’un problème est survenu durant la signature.<br>
            Votre mandat n’a pas été créé.<br>
            Si le problème persiste, veuillez contacter votre agence.
          </p>
        }
        @if (typeReturn === 'expired') {
          <p>
            Cette page a expirée.
          </p>
        }
        @if (typeReturn === 'error') {
          <p>
            Une erreur technique est survenue, merci de contacter le support client.
          </p>
        }
        @if (typeReturn === 'uncompleted') {
          <p>
            Afin de poursuivre le processus de signature de votre mandat veuillez contacter votre agence.
          </p>
        }
      </mat-card-content>
    }
  </mat-card>

  @if (!activatedAccount()) {
    <mat-card appearance="outlined">
      <mat-card-title>Finaliser la création de mon compte</mat-card-title>
      <mat-card-content>
        <form [formGroup]="form">
          <mat-form-field>
            <mat-label>Mot de passe</mat-label>
            <input formControlName="password" matInput type="password">
            @if (form.get('password').hasError('required')) {
              <mat-error>
                Le mot de passe est requis
              </mat-error>
            }
            @if (form.get('password').hasError('minlength')) {
              <mat-error>
                Le mot de passe doit faire au minimum 8 caractères
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Confirmation de votre mot de passe</mat-label>
            <input [(ngModel)]="password" formControlName="passwordConfirm" matInput type="password">
            @if (form.get('passwordConfirm').hasError('required')) {
              <mat-error>
                La confirmation de mot de passe est requise
              </mat-error>
            }
            @if (form.get('passwordConfirm').hasError('mismatch')) {
              <mat-error>
                Les 2 mots de passes ne correspondent pas
              </mat-error>
            }
          </mat-form-field>
          <p>
            <button (click)="setPassword()" [disabled]="form.get('password').errors !== null || form.get('passwordConfirm').errors !== null"
              mat-button>Définir mon
              mot de passe
            </button>
          </p>
        </form>
      </mat-card-content>
    </mat-card>
  }
